import { IconDevices } from '@tabler/icons-react';

const digitalUnits = {
    id: 'digital-units',
    title: 'DIGITAL UNITS',
    icon: IconDevices,
    type: 'group',
    url: '/digital-units',
    breadcrumbs: false,
    tags: [
        'digital unit',
        'digital units',
        'unit',
        'units',
        'device',
        'devices',
        'digital device',
        'digital devices',
        'unit management',
        'device management',
        'unit list',
        'device list',
        'unit setup',
        'unit configuration',
        'unit details',
        'unit account',
        'unit deployment',
        'unit access',
        'registered units',
        'active units',
        'unit overview'
    ]
};

export default digitalUnits;